import { render, staticRenderFns } from "./PainterIncome.vue?vue&type=template&id=10780d48&scoped=true"
import script from "./PainterIncome.vue?vue&type=script&lang=js"
export * from "./PainterIncome.vue?vue&type=script&lang=js"
import style0 from "./PainterIncome.vue?vue&type=style&index=0&id=10780d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10780d48",
  null
  
)

export default component.exports